export default __webpack_public_path__ + "static/media/Compare_2.84c76b22.svg";